import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GetToken } from '../../actions';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Spinner from '../../components/Spinner/Spinner';
import BPOLogo from '../../images/bpoLogo.jpg';
import './authpage.scss';

function AuthPage() {
  const [{ email, password }, setDetails] = useState({
    email: '',
    password: '',
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(GetToken({ email, password, navigate }));
  };

  const loggedIn = useSelector((state) => state.auth.email && state.auth.id);
  const type = useSelector((state) => state.auth.role && state.auth.role);
  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isLoading = useSelector((state) => state.auth.loading);

  useEffect(() => {
    if (loggedIn) {
      if (type === 'marketer') {
        navigate('/marketing-exec-dashboard');
      } else if (type === 'admin') {
        navigate('/operations-overview');
      } else if (type === 'snr_marketer') {
        navigate('/dashboard');
      }
    }
  }, [navigate, loggedIn, type]);

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        dispatch({ type: 'CLEAR_ERROR_MESSAGE' });
      }, 2000);
    }
  }, [dispatch, errorMessage]);
  const gotoForgotPassword = () => {
    navigate('/reset_password');
  };

  return (
    <>
      {isLoading && <Spinner />}
      <div className="authpage">
        <img src={BPOLogo} alt="BPO Logo" className="bpologo" />
        <div className="authpage__card">
          <h1>Welcome!</h1>
          <form onSubmit={handleSubmit}>
            <span>Login to Your Account</span>
            <Input
              placeholder="Enter email"
              type="email"
              label="Email"
              value={email}
              required
              onChange={(e) => setDetails((curr) => ({ ...curr, email: e.target.value }))}
              labelStyle={{ marginBottom: '10px' }}
            />
            <Input
              placeholder="Enter password"
              type="password"
              value={password}
              required
              label="Password"
              onChange={(e) => setDetails((curr) => ({ ...curr, password: e.target.value }))}
              labelStyle={{ marginBottom: '10px' }}
            />
            <p style={{ color: 'red', fontSize: '14px' }}>{errorMessage}</p>
            <Button
              style={{
                marginTop: '20px',
                fontSize: '16px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                marginLeft: 'auto',
              }}
              type="submit"
              text="Login"
            />
            <span className="forgot-password" onClick={gotoForgotPassword}>
              Forgot your password?
            </span>
          </form>
        </div>
      </div>
    </>
  );
}

export default AuthPage;
